import { ApplicationEnvironment } from './envModel';

export function getApplicationEnv(): ApplicationEnvironment {
    return process.env.VAROS_ENV as any;
}

export const IS_DEVELOPMENT = process.env.VAROS_ENV === 'development';
export const IS_STAGING = process.env.VAROS_ENV === 'stage';
export const IS_PRODUCTION = process.env.VAROS_ENV === 'production';
